import React from 'react';
import '../styles/components/square-button.css'

const SquareButton = ({ label, color, onClick, height, width }) => (
  <button className="square-button" style={{backgroundColor:color, height:height, width:width}} onClick={onClick}>
    <p>{label}</p>
  </button>
);

export default SquareButton;